module.exports = " <div class=satellite> <span class=satellite-title data-toggle=modal data-target=#modal-satellite>Suscríbete</span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Satellite.vue
// module id = 547
// module chunks = 0